import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { cn } from "@/lib/utils";
import { FileText, LayoutGrid, Blocks, LogOut, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";

const links = [
  { to: "/rechnungen", label: "Rechnungen", icon: LayoutGrid, testid: "nav-invoices" },
  { to: "/bausteine", label: "Bausteine", icon: Blocks, testid: "nav-bausteine" },
];

export const AppShell = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <header className="h-14 shrink-0 bg-white border-b border-slate-200 flex items-center px-4 md:px-6 gap-6 z-20">
        <button
          data-testid="brand-home"
          onClick={() => navigate("/rechnungen")}
          className="flex items-center gap-2 group"
        >
          <div className="h-7 w-7 bg-primary flex items-center justify-center">
            <FileText className="h-4 w-4 text-white" />
          </div>
          <span className="font-heading font-extrabold text-lg tracking-tight text-slate-900">
            FAKTURA
          </span>
        </button>

        <nav className="flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className={({ isActive }) =>
                cn(
                  "flex items-center gap-2 px-3 py-1.5 text-sm font-medium transition-colors duration-150",
                  isActive
                    ? "bg-slate-100 text-primary"
                    : "text-slate-600 hover:text-slate-900 hover:bg-slate-50"
                )
              }
            >
              <l.icon className="h-4 w-4" />
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-3">
          <Button
            data-testid="new-invoice-btn"
            onClick={() => navigate("/editor")}
            className="rounded-none bg-primary hover:bg-[#00227A] text-white gap-2 h-9"
          >
            <Plus className="h-4 w-4" /> Neue Rechnung
          </Button>
          <div className="hidden md:flex flex-col items-end leading-tight">
            <span className="text-xs font-medium text-slate-900">{user?.name}</span>
            <span className="text-[11px] text-slate-400">{user?.email}</span>
          </div>
          <Button
            data-testid="logout-btn"
            variant="ghost"
            size="icon"
            onClick={logout}
            className="rounded-none text-slate-500 hover:text-destructive"
          >
            <LogOut className="h-4 w-4" />
          </Button>
        </div>
      </header>
      <main className="flex-1 min-h-0">{children}</main>
    </div>
  );
};
